import { render, staticRenderFns } from "./LandingPagesList.vue?vue&type=template&id=24d672d1&scoped=true"
import script from "./LandingPagesList.vue?vue&type=script&lang=js"
export * from "./LandingPagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d672d1",
  null
  
)

export default component.exports